export const elvis = val => {
  return val ? val : null;
};

export const search = (id, parent, field) => {
  if (id && parent && parent.length > 0) {
    const stack = [...parent];
    while (stack.length) {
      const node = stack.pop();
      if (node[field] === id) return node;
      node.children && stack.push(...node.children);
    }
    return stack.pop() || null;
  } else {
    return null;
  }
};

export const fillData = (data, len) => {
  // Check if we're dealing with Spring Page format or old format
  const dataArray = data.content || data.data;  // remove data.data in the future
  
  const l = dataArray.length;
  if (l < len) {
    const lastIndex = Math.max(...dataArray.map(e => e.id), 0); // Use 0 as fallback if array is empty
    for (var i = 1; i <= (len - l); i++) {
      dataArray.push({ id: lastIndex + i, dummy: true });
    }
    
    // Update the appropriate total count field
    if (data.content) {
      data.totalElements = dataArray.length;
    } else {
      data.totalCount = dataArray.length;
    }
  }
}

// `value` matches the server's `TypeEnterprise` enum (used in
// /api/types/<value-lowercased>/... lookups).
// `name` is the display string (page title, etc.).
// `apiPath` is the server URL segment for /api/<apiPath>/... enterprise
// CRUD endpoints — needed as a separate field because for OrdinaryBuilding
// Phase 1 kept the route at /api/building (not /api/ordinary-building) for
// backward compat, and NonOrdinaryBuilding lives at /api/non-ordinary-building
// (hyphens, not the enum's underscores).
export const ENTERPRISE_TYPE = {
  FARM:                  { name: "Farm",                  value: "FARM",                  apiPath: "farm" },
  TLC:                   { name: "Telecommunication",     value: "TELECOMMUNICATION",     apiPath: "telecommunication" },
  ELECTRICAL:            { name: "Electrical",            value: "ELECTRICAL",            apiPath: "electrical" },
  TRANSPORT:             { name: "Transport",             value: "TRANSPORT",             apiPath: "transport" },
  ORDINARY_BUILDING:     { name: "Ordinary buildings",     value: "ORDINARY_BUILDING",     apiPath: "building" },
  NON_ORDINARY_BUILDING: { name: "Non-ordinary buildings", value: "NON_ORDINARY_BUILDING", apiPath: "non-ordinary-building" }
};

